/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const Components = Loadable(lazy(() => import("./index")));
const ContentList = Loadable(lazy(() => import("sections/models/content/list")));

const componentRoutes = [
    {
        path: "/components",
        element: <Components />,
    },
    {
        path: "/content/list",
        element: <ContentList />,
    },
];
export { componentRoutes };
